import React from 'react';
import { createTemplate } from '@/helpers/createTemplate';
import template from './templates/template';

export default function Banner() {
  return <>{createTemplate(template)}</>;
}
